import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    const _this = this

    App.modalEvent(_this.element, "hide.bs.modal", function() {
      const iframe = $(_this.element).find("iframe")
      iframe.attr("src", iframe.attr("src"))
    })
  }
}
